import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleRightMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconChevronTriangleRightMedium"><Path d="M9 8.11637C9.00027 7.05246 10.2453 6.47516 11.0576 7.16227L15.6465 11.0451C16.2363 11.5443 16.2362 12.454 15.6465 12.9533L11.0576 16.8361C10.2452 17.5235 9 16.9462 9 15.882V8.11637Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTriangleRightMedium;
